import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { DemoRoutes } from '@repo/shared/routes-demo'
import axios, { AxiosInstance } from 'axios'

import { apiAdmin } from '@/external/api/chunks/api-admin'
import { apiAlerts } from '@/external/api/chunks/api-alerts'
import { apiAuth } from '@/external/api/chunks/api-auth'
import { apiBeneficiaries } from '@/external/api/chunks/api-beneficiaries'
import { apiCaseWorkers } from '@/external/api/chunks/api-case-workers'
import { apiChatSessions } from '@/external/api/chunks/api-chat-sessions'
import { apiDocuments } from '@/external/api/chunks/api-documents'
import { apiMe } from '@/external/api/chunks/api-me'
import { apiOrganizations } from '@/external/api/chunks/api-organizations'
import { apiSudo } from '@/external/api/chunks/api-sudo'
import { apiUsers } from '@/external/api/chunks/api-users'
import { buildOrganizationDemoFromDto } from '@/external/api/helpers'
import { IApi } from '@/store/spi/api.ts'
import { ISudoApi } from '@/store/spi/sudo.ts'

export interface ISudo {
  sudo: ISudoApi
}

export class AxiosAPI {
  private axios: AxiosInstance

  constructor(baseUrl: string) {
    this.axios = axios.create({
      baseURL: baseUrl + '/',
    })
  }

  api = (): IApi & { sudo: ISudoApi } & {} => {
    const o = apiOrganizations(this.axios)
    const u = apiUsers(this.axios)
    return {
      //
      // SUDO
      //
      sudo: apiSudo({
        organizations: o.sudo,
        users: u.sudo,
      })(this.axios),

      //
      // ADMIN
      //
      admin: apiAdmin(this.axios),

      //
      // DEMO
      //
      demo: {
        get: async () => {
          const res = await tryCatch(async () => {
            const response = await this.axios.get<DemoRoutes.get.Response>(DemoRoutes.get.call())
            return response
          })
          if (hasError(res)) return handleError(res)
          return {
            organizations: res.organizations.map(buildOrganizationDemoFromDto),
          }
        },
        reset: async (p: { organizationId: string }) => {
          const res = await tryCatch(async () => {
            const response = await this.axios.patch<DemoRoutes.reset.Response>(
              DemoRoutes.reset.call(p),
            )
            return response
          })
          if (hasError(res)) return handleError(res)
          return res
        },
      },
      //
      // APP
      //
      alerts: apiAlerts(this.axios).app,
      auth: {
        ...apiAuth(this.axios).app,
        updateAccessToken: (p: { accessToken: string }): void => {
          this.axios.defaults.headers['Authorization'] = `Bearer ${p.accessToken}`
        },
      },
      beneficiaries: apiBeneficiaries(this.axios).app,
      caseWorkers: apiCaseWorkers(this.axios).app,
      chatSessions: apiChatSessions(this.axios).app,
      documents: apiDocuments(this.axios).app,
      me: apiMe(this.axios).app,
      organizations: o.app,
    }
  }
}
